class VisualStarRating {
  constructor() {
    this.init();
  }

  init() {
    // Add click event listeners to all visual star rating elements
    const starRatings = document.querySelectorAll('.visual-star-rating');
    
    starRatings.forEach(rating => {
      rating.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollToReviews();
      });
    });
  }

  scrollToReviews() {
    // First try to find the Loox reviews section
    const looxReviews = document.getElementById('looxReviews');
    
    if (looxReviews) {
      // Smooth scroll to Loox reviews section
      looxReviews.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      // Fallback to generic reviews section
      const reviewsSection = document.getElementById('shopify-product-reviews');
      
      if (reviewsSection) {
        reviewsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        // Final fallback: scroll to bottom of page if no reviews section found
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new VisualStarRating();
});

// Also initialize if DOM is already loaded (for dynamic content)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VisualStarRating();
  });
} else {
  new VisualStarRating();
}

